import AddUserGroupContainer from "../add/AddUserGroupContainer";

interface EditUserGroupProps {
  groupId: string;
  onModal: (type?: string) => void;
  onSuccessDelete?: () => void;
}

export default function EditUserGroup(props: EditUserGroupProps): JSX.Element {
  return <AddUserGroupContainer {...props} />;
}
